import { motion } from 'motion/react'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Group = styled(motion.g)`
  fill: black;
`

export const PathAmu = styled(motion.path)`
  transform: translateY(85%);
`

export const PathTagline = styled(motion.path)`
  transform: translateY(10%);
  fill-rule: evenodd;
  clip-rule: evenodd;
`
